import { FC, ReactNode } from 'react';

import { mainnet } from '@starknet-react/chains';
import { StarknetConfig } from '@starknet-react/core';
import { starknetConnectors, starknetProvider } from './starknetConfig';

interface StarknetProviderProps {
  children: ReactNode;
}

const StarknetProvider: FC<StarknetProviderProps> = ({ children }) => (
  <StarknetConfig chains={[mainnet]} provider={starknetProvider} connectors={starknetConnectors}>
    {children}
  </StarknetConfig>
);

export default StarknetProvider;
